import script from "./STDSDC01C12AddressListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./STDSDC01C12AddressListModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__